import BannerLogo from "../../assets/Images/headerImg.svg";
const Banner = ({ path }) => {
  return (
    <>
      <div className="bg-[#F2F2F2]">
        <div className="custom-container">
          <div className="text-[#161412] font-[14px] my-[4px]">{path}</div>
          <div className="max-w-[718px] mx-auto py-[10px]">
            <img src={BannerLogo} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};
export default Banner;
